<template>
    <div>
        <NavBar></NavBar>
        <div class="pay_finish">
            <van-col span='24' style="font-weight:bold">{{payText}}</van-col>
            <van-col span='24' style="font-size:12px;color:grey;padding-top:20px">支付金额：20000.00元</van-col>
            <van-col span='24' style="font-size:12px;color:grey;padding-top:20px">正在等待支付结果，请勿关闭本页面。</van-col>
        </div>
        <div class="flex">
            <van-col :span="24" class="house_button">
                <van-button type="danger" size="normal" @click="goHome">返回首页</van-button>
            </van-col>
            <!-- <van-button type="danger" size="large" @click="goHome">返回首页</van-button> -->
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            math:1,
            payText:'等待中...',
        }
    },
    methods:{
        Finish(){
            if(this.math==0){
                this.payText='等待中...'
            }else if(this.math==1){
                this.payText='支付完成'
            }
        },
        /**
         * 返回首页
         */
        goHome(){
            history.go(-1)
            // this.$router.push({
            //     path: '/'
            // });
        }
    },
    created(){
        this.Finish()
    }
}
</script>

<style scoped>
.pay_finish{
    padding-top: 80px;
    text-align: center;
}
.flex{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
}
.flex .house_button{
    margin: 10px;
}
.flex  .house_button .van-button,.content_button .van-button{
    padding: 3px 15px;
    width: 100%;
}
</style>